export const ExecutingAuthorityRender = (params: any) => {
    const { row } = params
    return <span>{row?.executingAuthority} ({row?.executingAuthorityContact})</span>
}
